// agents/src/services/adminStatsService.js
import { getApiConfig } from '../config/markets.js';

const API_URL = getApiConfig().apiUrl;

async function adminFetch(path, query = '') {
  const token = localStorage.getItem('token');
  if (!token) throw new Error('No token');

  const url = `${API_URL}/admin/stats${path}${query ? `?${query}` : ''}`;
  const res = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    let msg = 'Admin stats request failed';
    try {
      const data = await res.json();
      msg = data.message || data.error || msg;
    } catch {}
    throw new Error(msg);
  }
  return res.json();
}

export const fetchOverview = (q) => adminFetch('/overview', q);
export const fetchMessagesSeries = (q) => adminFetch('/messages', q);
export const fetchMessagesHeatmap = (q) => adminFetch('/messages/heatmap', q);
export const fetchConversationsByStatus = (q) => adminFetch('/conversations/by-status', q);
export const fetchConversationsNewSeries = (q) => adminFetch('/conversations/new', q);
export const fetchAgents = (q) => adminFetch('/agents', q);
export const fetchAgentDetail = (id, q) => adminFetch(`/agents/${id}`, q);
export const fetchResponseTimes = (q) => adminFetch('/response-times', q);
export const fetchTopTemplates = (q) => adminFetch('/templates', q);
export const fetchTopQuickReplies = (q) => adminFetch('/quick-replies', q);
export const fetchReassignmentsSeries = (q) => adminFetch('/audit/reassignments', q);
export const fetchActionsByAgent = (q) => adminFetch('/audit/actions-by-agent', q);
export const fetchBlockedStats = (q) => adminFetch('/blocked', q);
export const fetchFunnelIT = (q) => adminFetch('/funnel/it', q);
export const fetchAlerts = (q) => adminFetch('/alerts', q);
export const fetchGhostLeadsSeries = (q) => adminFetch('/integrations/ghost-leads', q);
